import { useEffect } from 'react';
import { useBrandingStore } from '@/store/branding.store';

export function BrandingLoader({ children }: { children: React.ReactNode }) {
  const loadBranding = useBrandingStore((s) => s.loadBranding);

  useEffect(() => {
    loadBranding();
  }, [loadBranding]);

  return <>{children}</>;
}
